// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-container-yPz_H {
  min-width: 1000px;
  height: 100%;
  display: flex;
  gap: 20px;
  flex-direction: column;
  padding: 16px;
}

.sales-header-NZ5w4 {
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: flex-start;
}

.sales-salesItems-B6_5q {
  display: flex;
  gap: 24px;
}

.sales-item-FeIZS {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.sales-title-XuVEF {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.75);
}

.sales-amount-F3IuL {
  color: var(--money-color);
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
}

.sales-options-CcBOZ {
  display: flex;
  gap: 12px;
}

.sales-content-gWBmI {
  display: flex;
  flex-grow: 1;
  gap: 40px;
  padding: 0px 4px 4px;
}

.sales-chartsContainer-_IoCB {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 20px;
}

.sales-topCharts-MvMlN {
  display: flex;
  gap: 20px;
  flex: 1;
}

.sales-bottomChart-E4kb6 {
  display: flex;
  flex: 1;
}

.sales-chartCard-gCU9V {
  flex: 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sales-chartCardloading-g6U_N {
  background-color: var(--color-neutral-50);
  animation: sales-pulse-rzc51 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.sales-chartCardloading-g6U_N > * {
  visibility: hidden;
}

@keyframes sales-pulse-rzc51 {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.sales-chartTitle-MPBvK {
  color: var(--color-neutral-800);
  font-size: 15px;
  font-weight: var(--font-weight-medium);
}

.sales-chartPlaceholder-vVRbd {
  flex: 1;
  background-color: var(--color-neutral-50);
  border: 1px dashed var(--color-neutral-200);
  border-radius: var(--radius-2xl);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-neutral-400);
  font-size: 13px;
}

.sales-empty-sPMKw {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  color: var(--color-neutral-500);
}

.sales-error-FDBHY {
  height: 100%;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/business/sales/sales.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,qEAAyD;AAC3D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,OAAO;EACP,yCAAyC;EACzC,2CAA2C;EAC3C,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB","sourcesContent":[".container {\n  min-width: 1000px;\n  height: 100%;\n  display: flex;\n  gap: 20px;\n  flex-direction: column;\n  padding: 16px;\n}\n\n.header {\n  display: flex;\n  flex-shrink: 0;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.salesItems {\n  display: flex;\n  gap: 24px;\n}\n\n.item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.amount {\n  color: var(--money-color);\n  font-size: 14px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.options {\n  display: flex;\n  gap: 12px;\n}\n\n.content {\n  display: flex;\n  flex-grow: 1;\n  gap: 40px;\n  padding: 0px 4px 4px;\n}\n\n.chartsContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 20px;\n}\n\n.topCharts {\n  display: flex;\n  gap: 20px;\n  flex: 1;\n}\n\n.bottomChart {\n  display: flex;\n  flex: 1;\n}\n\n.chartCard {\n  flex: 1;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.chartCardloading {\n  background-color: var(--color-neutral-50);\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.chartCardloading > * {\n  visibility: hidden;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.chartTitle {\n  color: var(--color-neutral-800);\n  font-size: 15px;\n  font-weight: var(--font-weight-medium);\n}\n\n.chartPlaceholder {\n  flex: 1;\n  background-color: var(--color-neutral-50);\n  border: 1px dashed var(--color-neutral-200);\n  border-radius: var(--radius-2xl);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-neutral-400);\n  font-size: 13px;\n}\n\n.empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  color: var(--color-neutral-500);\n}\n\n.error {\n  height: 100%;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sales-container-yPz_H`,
	"header": `sales-header-NZ5w4`,
	"salesItems": `sales-salesItems-B6_5q`,
	"item": `sales-item-FeIZS`,
	"title": `sales-title-XuVEF`,
	"amount": `sales-amount-F3IuL`,
	"options": `sales-options-CcBOZ`,
	"content": `sales-content-gWBmI`,
	"chartsContainer": `sales-chartsContainer-_IoCB`,
	"topCharts": `sales-topCharts-MvMlN`,
	"bottomChart": `sales-bottomChart-E4kb6`,
	"chartCard": `sales-chartCard-gCU9V`,
	"chartCardloading": `sales-chartCardloading-g6U_N`,
	"pulse": `sales-pulse-rzc51`,
	"chartTitle": `sales-chartTitle-MPBvK`,
	"chartPlaceholder": `sales-chartPlaceholder-vVRbd`,
	"empty": `sales-empty-sPMKw`,
	"error": `sales-error-FDBHY`
};
export default ___CSS_LOADER_EXPORT___;
